<template>
  <div id="app">
    <HeaderComponent v-if="content.organization" :content="content" />
    <main>
      <router-view v-if="!loading" />
      <div v-else class="loading">
        <p>Loading...</p>
      </div>
    </main>
    <FooterComponent v-if="content.organization" :content="content" />
  </div>
</template>

<script>
import { loadAllContent } from './utils/contentLoader'
import HeaderComponent from './components/HeaderComponent.vue'
import FooterComponent from './components/FooterComponent.vue'
import { languageStore } from './store/language'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent
  },
  data() {
    return {
      content: {},
      loading: true
    }
  },
  provide() {
    return {
      content: () => this.content
    }
  },
  async mounted() {
    try {
      this.content = await loadAllContent()
      this.updatePageTitle()
    } catch (error) {
      console.error('Failed to load content:', error)
    } finally {
      this.loading = false
    }
  },
  watch: {
    '$route'() {
      this.updatePageTitle()
    }
  },
  methods: {
    updatePageTitle() {
      const lang = languageStore.currentLanguage
      const orgName = lang === 'en'
        ? this.content.organization?.name || 'CLIMB'
        : this.content.organization?.nameZh || '圣工联会'

      document.title = `${orgName} - ${this.$route.name || 'Home'}`
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}
</style>
